import {
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { Wind } from "lucide-react";

export const ISPU_DISTRICT_COLORS = {
  Sukadana: "#38bdf8",
  "Simpang Hilir": "#f97316",
  "Teluk Batang": "#22c55e",
  Seponti: "#facc15",
  "Pulau Maya": "#a78bfa",
  "Kepulauan Karimata": "#f472b6",
};

export default function IspuTrend({ data = [], districts = [], compact = false }) {
  return (
    <section
      className={`trend-panel hs-trend ispu-trend ${compact ? "it-compact" : ""}`}
      data-testid="ispu-trend-panel"
    >
      <div className="panel-heading">
        <div>
          <span className="section-kicker">TREN ISPU 7 HARI</span>
          <h3>Kualitas udara harian · dampak asap</h3>
        </div>
        <Wind size={17} />
      </div>
      <div className="ispu-trend-key">
        {districts.map((d) => (
          <span key={d}>
            <i style={{ background: ISPU_DISTRICT_COLORS[d] || "#94a3b8" }} /> {d}
          </span>
        ))}
      </div>
      <div className="chart" data-testid="ispu-trend-chart">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 6, right: 8, left: 0, bottom: 0 }}>
            <XAxis
              dataKey="label"
              tick={{ fill: "#718178", fontSize: 10 }}
              interval={0}
            />
            <YAxis
              tick={{ fill: "#718178", fontSize: 10 }}
              width={32}
              allowDecimals={false}
              domain={[0, (max) => Math.max(60, Math.ceil(max * 1.15))]}
            />
            <ReferenceLine
              y={100}
              stroke="#facc15"
              strokeDasharray="5 4"
              strokeOpacity={0.55}
              label={{
                value: "Tidak Sehat >100",
                fill: "#facc15",
                fontSize: 9,
                position: "insideTopRight",
              }}
            />
            <Tooltip
              contentStyle={{
                background: "#0f2440",
                border: "1px solid #2a5488",
                color: "#f1f5f9",
                fontSize: 12,
              }}
              formatter={(value, name) => [`ISPU ${value}`, name]}
            />
            {districts.map((d) => (
              <Line
                key={d}
                type="monotone"
                dataKey={d}
                stroke={ISPU_DISTRICT_COLORS[d] || "#94a3b8"}
                strokeWidth={1.8}
                dot={{ r: 2 }}
                connectNulls
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </div>
      {!compact && (
        <div className="hs-trend-foot">
          <Wind size={13} />
          <span>
            ISPU harian dari rata-rata PM2.5 &amp; PM10 (Open-Meteo/CAMS) ·
            0–50 Baik · 51–100 Sedang · 101–200 Tidak Sehat
          </span>
        </div>
      )}
    </section>
  );
}
